import type { i18nText } from "utils/i18n";

export type TErrorTexts = {
  message: null | string;
  title: null | string;
};

type TErrorActions = {
  closeText?: i18nText | null; // null means no close button
  onClose?: () => void;
  onRetry?: () => void;
  retryText?: i18nText | null; // null means no retry text
};

export abstract class EntitleError extends Error {
  readonly actions?: TErrorActions;
  suppressError = false;
  readonly title: null | string;

  constructor(message?: string, title?: string, actions?: TErrorActions, suppressError = false) {
    super(message);
    this.title = title || null;
    this.actions = actions;
    this.suppressError = suppressError;
  }

  getActions(): TErrorActions {
    return this.actions || {};
  }

  getTexts(): TErrorTexts {
    return {
      message: this.message,
      title: this.title,
    };
  }
}
